import {
	AllRolePermissions,
	PricingPlanNames,
	UserData,
	UserRole
} from "@/Contracts/Users";
import { checkUseFeatureAccess } from "@/Hooks/utils";
import { useContext } from "react";
import { ParentContext } from "../store/context/ParentContext";

/**
 *
 * @param requiredPlan: Required pricing plan for the user to access this Feature.
 * If all users should be able to access this feature then pass **IGNITE**.
 * All the old accounts existing before pricing plan won't have any **PRICING PLAN** for their account
 * and will have access to all feature by default.
 *
 * @param requiredRole: Required User Role to access this feature.
 * If all users should be able to access this feature then pass **UserRole.UserRole**
 *
 * @description processes whether the user should be able to view feature based on the **USER ROLE** and
 * **CURRENT ACTIVE PRICING PLAN**
 */

const useFeatureAccess = (
	requiredPlan: PricingPlanNames,
	requiredRole: UserRole,
	permissions?: AllRolePermissions[],
	skipPermissions?: boolean
): boolean => {
	const parentContext = useContext(ParentContext);
	return checkUseFeatureAccess(
		(parentContext.user.userData as UserData)?.role,
		(parentContext.user.userData as UserData)?.roles_permissions
			?.permissions,
		parentContext.user.subscriptions.find(plan => plan.current_plan)
	)(requiredPlan, requiredRole, permissions, skipPermissions);
};

export default useFeatureAccess;
